module.exports = __webpack_public_path__ + "img/corner-right-up.be59dce7.svg";